import { H1, BodyLarge } from '../ui/Typography';

export default function PortfolioHeader() {
  return (
    <div className="text-center mb-12">
      <H1 className="text-primary mb-2">Portfolio</H1>
      <BodyLarge className="text-gray-600">
        Professional Real Estate Management for Sustainable Yields
      </BodyLarge>
    </div>
  );
}